<template>
  <v-card style="height: 100%">
    <project-flow-navigation-toolbar
      :title="apartmentTypeName"
    ></project-flow-navigation-toolbar>

    <v-toolbar dark dense>
      <v-tabs v-model="tab">
        <v-tab href="#details"> Details </v-tab>
      </v-tabs>
    </v-toolbar>

    <v-tabs-items
      style="height: calc(100% - 112px); position: relative"
      v-model="tab"
    >
      <v-tab-item style="height: 100%" value="details">
        <v-card class="full-height-card">
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  class="mt-5"
                  dense
                  v-model="apartmentType.name"
                  label="Name"
                ></v-text-field>
              </v-col>
              <v-col cols="2" sm="2" md="2">
                <v-text-field
                  outlined
                  dense
                  v-model="apartmentType.order"
                  label="Order"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  dense
                  v-model="apartmentType.rooms"
                  label="Rooms"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  dense
                  v-model="apartmentType.area"
                  label="Area"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="8">
                <v-jsoneditor
                  v-model="apartmentType.properties"
                  :plus="true"
                  height="300px"
                  :options="{
                    mode: 'code',
                    theme: 'ace/theme/tomorrow_night_bright',
                    mainMenuBar: false
                  }"
                ></v-jsoneditor>
              </v-col>
            </v-row>
            <!-- <v-row>
              <v-card outlined>
                <v-card-title
                  >Apartment custom properties form preview</v-card-title
                >
                <v-form-base
                  :model="myModel"
                  :schema="mySchema"
                  @input="handleInput"
                />
              </v-card>
            </v-row> -->
          </v-card-text>
          <v-spacer />
          <v-card-actions>
            <v-btn color="red darken-1" @click="deleteApartmentType"
              >Delete</v-btn
            >
            <v-spacer></v-spacer>
            <v-fade-transition>
              <span v-if="changeDetected" class="caption amber--text d-flex align-center mr-2">
                <v-icon x-small color="amber" class="mr-1">mdi-circle-medium</v-icon>Unsaved changes
              </span>
            </v-fade-transition>
            <v-btn v-if="changeDetected" text @click="discard">Discard</v-btn>
            <v-btn
              color="blue darken-1"
              :disabled="saveButtonDisabled"
              @click="save"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import ProjectFlowNavigationToolbar from '../../components/AppBar/ProjectFlowNavigationToolbar'
import Enums from '../../helpers/Enums'
import VJsoneditor from 'v-jsoneditor/src/index'
import 'brace'
import 'brace/theme/tomorrow_night_bright'
import VFormBase from 'vuetify-form-base'
import { mapState } from 'vuex'

export default {
  name: 'ApartmentExplore',
  props: {},
  components: {
    ProjectFlowNavigationToolbar,
    VJsoneditor
  },
  data: function() {
    return {
      pois: [],
      apartmentType: {},
      apartmentTypeId: null,
      title: '',
      tab: 'details',
      changeDetected: false,
      myModel: {},
      mySchema: {}
    }
  },
  computed: {
    ...mapState('ApartmentTypeStore', ['selectedApartmentType']),
    apartmentTypeName: function() {
      return this.selectedApartmentType ? this.selectedApartmentType.name : ''
    },
    saveButtonDisabled: function() {
      return !this.changeDetected
    }
  },
  methods: {
    getData: async function() {
      if (this.apartmentTypeId) {
        await this.$store.dispatch(
          'ApartmentTypeStore/setSelectedApartmentType',
          this.apartmentTypeId,
          { root: true }
        )
        this.apartmentType = JSON.parse(
          JSON.stringify(this.selectedApartmentType)
        )
        if (
          this.selectedApartmentType.properties &&
          Object.prototype.hasOwnProperty.call(
            this.selectedApartmentType.properties,
            'apartmentFieldsSchema'
          )
        ) {
          this.mySchema = this.selectedApartmentType.properties[
            'apartmentFieldsSchema'
          ]
        }
      }
    },
    save: async function() {
      await this.$store.dispatch(
        'ApartmentTypeStore/updateApartmentType',
        this.apartmentType
      )
      await this.getData()
      // Upisivanje updateovanog apartmenttypea se sada vrsi u update apartmenttype akciji:
      // await this.$store.dispatch(
      //   'ApartmentTypeStore/setSelectedApartmentType',
      //   this.$route.params.apartmentTypeId
      // )
      this.apartmentType = JSON.parse(
        JSON.stringify(this.selectedApartmentType)
      )
      this.changeDetected = false
    },
    discard() {
      this.apartmentType = JSON.parse(JSON.stringify(this.selectedApartmentType))
      this.changeDetected = false
    },
    deleteApartmentType: async function() {
      this.$confirm({
        title: 'Delete Apartment Type',
        text: 'Are you sure?',
        acceptText: 'DELETE',
        cancelText: 'CANCEL'
      })
        .then(y => {
          this.$store
            .dispatch(
              'ApartmentTypeStore/deleteApartmentType',
              this.$route.params.apartmentTypeId
            )
            .then(
              () => {
                this.$router.go(-1)
                this.$emit('deleted')
              },
              err => {
                this.$store.dispatch(
                  'NotificationStore/add',
                  {
                    type: 'error',
                    message: err.message
                  },
                  { root: true }
                )
              }
            )
        })
        .catch(n => {
          console.log('NO')
        })
    },
    handleInput(val) {
      console.log(val)
    }
  },
  created: function() {},
  mounted: function() {},
  watch: {
    apartmentType: {
      // This will let Vue know to look inside the object
      deep: true,
      handler: function(after, before) {
        if (JSON.stringify(before) !== '{}') {
          this.changeDetected =
            JSON.stringify(this.apartmentType) !==
            JSON.stringify(this.selectedApartmentType)
        }
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.apartmentTypeId = to.params.apartmentTypeId
      vm.getData()
    })
  },
  async beforeRouteUpdate(to, from, next) {
    this.apartmentTypeId = to.params.apartmentTypeId
    await this.getData()
    next()
  }
}
</script>

<style scoped></style>
